import { seoText } from './seo'

/** Invalid page identifiers must never create another copy of page one. */
export const listingPageNumber = (value?: string | string[]): number => {
  if (value === undefined) return 1
  if (typeof value !== 'string' || !/^[1-9]\d*$/.test(value)) return 0
  const page = Number(value)
  // Catalog routes use 24 products per page. Validate the actual database
  // offset and end limit too, rather than permitting rounded skip values.
  return Number.isSafeInteger(page) && Number.isSafeInteger(page * 24) ? page : 0
}

export const listingPagePath = (path: string, page: number): string => {
  const base = path.split(/[?#]/)[0].replace(/\/$/, '').replace(/\/seite\/\d+$/, '')
  return page > 1 ? `${base}/seite/${page}` : base
}

export const withBrandContext = (value?: string, brand?: string): string => {
  const text = seoText(value)
  const brandName = seoText(brand)
  if (!brandName || text.toLocaleLowerCase('de').includes(brandName.toLocaleLowerCase('de'))) return text
  return text ? `${text} von ${brandName}` : brandName
}

export const listingPageTitle = (title: string | undefined, page: number) =>
  page > 1 ? `${seoText(title) || 'Produkte'} – Seite ${page}` : title
